import { civilStatus } from 'shared/statusCivilList';

export const initialValues = {
  name: '',
  email: '',
  cpf: '',
  cell_phone: '',
  birth_date: '',
  genre: '',
  civil_status: '',
  password: '',
  password_confirm: '',
  address: {
    code_post: '',
    street: '',
    number: '',
    district: '',
    complement: '',
    city: {
      id: null,
      name: '',
      state: {
        id: null,
        name: '',
        uc: '',
      },
    },
  },
  crm: {
    number: '',
    state: null,
  },
  specialties: [],
};

export const genreOptions = [
  { label: 'Masculino', value: 'M' },
  { label: 'Feminino', value: 'F' },
  { label: 'Outro', value: 'O' },
];

export const civilStatusOptions = civilStatus.map((item) => ({
  label: item.name,
  value: String(item.id),
}));

export const STEP_LABELS = [
  'Dados pessoais',
  'Endereço',
  'Dados profissionais',
];
